/**
 * Browser Fingerprint Interceptor
 * 浏览器指纹拦截器，用于为每个请求添加唯一的浏览器指纹标识
 */

import { psAxios } from '@patsnap/common-ps-http';
import * as _ from 'lodash';
import { getBrowserFingerprint } from '@patsnap-utils/browser-fingerprint';
import { initCookie } from '../../utils/init-cookie';
import type { AxiosRequestConfig } from 'axios';

/**
 * 浏览器指纹缓存
 * 避免重复计算，提升性能
 */
let fingerprint = '';

/**
 * 指纹拦截器函数
 * 为请求添加 X-Signature-ID 头部
 */
export const fingerprintInterceptor = async (
    config: AxiosRequestConfig,
): Promise<AxiosRequestConfig> => {
    // 如果指纹未生成，则生成指纹
    if (!fingerprint) {
        fingerprint = initCookie.getVisitorId() || '';
    }

    if (!fingerprint) {
        console.warn('Visitor ID is not available, generating browser fingerprint as fallback.');
        fingerprint = await getBrowserFingerprint();
    }

    // 合并请求头，添加指纹标识
    config.headers = _.merge({}, config.headers, {
        'X-Signature-ID': fingerprint,
    });

    return config;
};

/**
 * 注入指纹拦截器
 * 为 psAxios 实例添加请求拦截器
 */
export function injectFingerprintInterceptor() {
    // 避免重复注入
    if (!psAxios.psInterceptors.fingerprintInterceptor) {
        psAxios.psInterceptors.fingerprintInterceptor = psAxios.interceptors.request.use(
            fingerprintInterceptor,
        );
    }
}

/**
 * 移除指纹拦截器
 * 从 psAxios 实例中移除请求拦截器
 */
export function ejectFingerprintInterceptor() {
    if (psAxios.psInterceptors.fingerprintInterceptor !== undefined) {
        psAxios.interceptors.request.eject(
            psAxios.psInterceptors.fingerprintInterceptor,
        );
        // 清理引用
        delete psAxios.psInterceptors.fingerprintInterceptor;
    }
}

/**
 * 获取当前浏览器指纹
 * @returns 返回缓存的指纹，如果未生成则返回空字符串
 */
export function getFingerprint(): string {
    return fingerprint;
}

/**
 * 重置指纹缓存
 * 下次请求时会重新生成指纹
 */
export function resetFingerprint(): void {
    fingerprint = '';
}
